module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26971",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6991",
      "conversations-error-reporting": "static-1.8262",
      "conversations-internal-pub-sub": "static-1.15347",
      "conversations-internal-schema": "static-1.11990",
      "conversations-message-history": "static-1.10563",
      "conversations-test-sdk": "static-1.9802",
      "conversations-visitor-experience-components": "static-1.20334",
      "head-dlb": "static-1.4360",
      "hs-promise-utils": "static-1.4867",
      "hs-test-utils": "static-1.7340",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10857",
      "I18n": "static-7.1452",
      "jasmine-immutable": "static-1.2308",
      "jasmine-runner": "static-1.5765",
      "quartz": "static-1.6157",
      "react-dlb": "static-1.62",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.77",
      "urlinator": "static-1.3882",
      "viral-links-lib": "static-1.6250",
      "visitor-ui-component-library": "static-1.5506",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3909",
      "atom": "static-1.4495",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4135",
      "conversations-infrastructure": "static-1.8284",
      "conversations-prop-types": "static-1.6777",
      "conversations-visibility-tools": "static-1.5113",
      "conversations-visitor-message-history": "static-1.19071",
      "cssUtils": "static-1.601",
      "enviro": "static-4.328",
      "flux-actions": "static-1.286",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3531",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9058",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15941",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4734",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3720",
      "sanitize-text": "static-1.7495",
      "signup-constants": "static-1.17508",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.475",
      "usage-tracker": "static-1.6774",
      "usage-tracker-core": "static-1.6624",
      "usage-tracker-multi": "static-1.5188",
      "usage-tracker-public": "static-1.6585",
      "visitor-ui-component-library-icons": "static-1.5317",
      "hs-promise-rejection-tracking": "static-1.4750",
      "raven-hubspot": "static-1.5536",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2879",
      "moment": "static-3.26",
      "quartz-core": "static-1.5376",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4204",
      "foundations-components": "static-1.6847",
      "foundations-theming": "static-1.3686",
      "UIComponents": "static-3.7804",
      "cv-backend-services": "static-1.1336",
      "immutable-less": "static-1.3902",
      "conversations-skeleton-state": "static-1.6706",
      "crm-events-viz-core": "static-1.31181",
      "icons": "static-2.595",
      "react-input-autosize": "static-2.17",
      "tanstack-virtual": "static-1.14",
      "rpc-client-utils": "static-1.4042",
      "ui-images": "static-2.965",
      "permission-components": "static-1.4688",
      "react-virtualized": "static-2.81",
      "HeadJS": "static-2.623",
      "framer-motion": "static-1.52",
      "hs-test-utils-bend-plugin": "static-1.2451",
      "msw": "static-1.39",
      "testing-library": "static-1.134",
      "i18n-data": "static-1.207",
      "moment-timezone": "static-5.67",
      "jasmine": "static-4.3657",
      "quartz-core-utils": "static-1.3024",
      "signup-ui-url-generator": "static-2.7419",
      "HubStyle": "static-2.11165",
      "sassPrefix": "static-1.140",
      "csstype": "static-1.50",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5191",
      "dispatcher": "static-1.121",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.699",
      "hub-http-shared-msw-handlers": "static-1.8421",
      "hubspotter-http": "static-1.3995",
      "hubspotter-http-shared-msw-handlers": "static-1.8419",
      "mobile-manifest-mixins": "static-1.395",
      "platform-navigation-bootstrap": "static-1.11844",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.333",
      "hs-story-utils": "static-1.8708",
      "bend-plugin-foundations-components": "static-1.3116",
      "floating-ui": "static-1.40",
      "foundations-theming-specialty": "static-1.1402",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2169",
      "foundations-theming-base": "static-1.2671",
      "ts-schema": "static-1.3523",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.1822",
      "content-assistance-lib": "static-1.6971",
      "crm-component-utils": "static-1.37353",
      "crm-display-components": "static-1.23103",
      "crm-fe-perf": "static-1.22312",
      "crm-links": "static-1.5531",
      "crm-message-bus": "static-1.41165",
      "crm-search-service-types": "static-1.619",
      "crm-source-interpretation-lib": "static-1.4632",
      "customer-data-communicator": "static-1.43719",
      "customer-data-email": "static-1.16915",
      "customer-data-filters-ui": "static-1.37380",
      "customer-data-objects-ui-components": "static-1.12317",
      "customer-data-objects": "static-1.6983",
      "customer-data-properties": "static-1.49447",
      "customer-data-rte": "static-1.31490",
      "customer-data-ui-utilities": "static-1.9113",
      "data-fetching-client": "static-1.9009",
      "draft-plugins": "static-2.20508",
      "file-manager-components": "static-1.21734",
      "FileManagerCore": "static-1.37233",
      "frontend-preferences-client": "static-1.7281",
      "hubspot-apollo-client": "static-1.4167",
      "hubspot-prosemirror": "static-1.16440",
      "object-comments-thread-lib": "static-1.8995",
      "reference-resolvers-lite": "static-1.7392",
      "ui-addon-upgrades": "static-9.16967",
      "universal-associations-select": "static-1.10271",
      "platform-infra-nav-components": "static-1.7105",
      "graphql": "static-1.66",
      "ai-components-ui-library": "static-1.7262",
      "superstore": "static-1.4066",
      "ui-addon-video-player": "static-1.8099",
      "ui-coaching-tips": "static-1.26664",
      "card-properties-lib": "static-1.42319",
      "crm-actions": "static-1.5542",
      "crm-cards-sdk": "static-1.41614",
      "customer-data-properties-shared-msw-handlers": "static-1.7748",
      "customer-data-property-utils": "static-1.7310",
      "customer-data-tracking": "static-1.6189",
      "framework-data-schema-resolvers": "static-1.6236",
      "usage-tracker-container": "static-1.6764",
      "framework-data-table": "static-2.10496",
      "location-customization-utils-lib": "static-1.7238",
      "calling-error-reporting": "static-1.30634",
      "calling-internal-common": "static-1.30628",
      "calling-usage-tracker": "static-1.5838",
      "crm_data": "static-4.89904",
      "crm_schema": "static-3.89943",
      "crm-legacy-global-containers": "static-1.23134",
      "customer-data-content": "static-1.26064",
      "draft-content-plugins": "static-1.26839",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.22827",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22526",
      "EmailSignatureEditor": "static-1.23062",
      "FileManagerLib": "static-1.37374",
      "hubspot-prosemirror-plugins": "static-1.16432",
      "integration-settings-components": "static-1.13411",
      "integrations-lib": "static-1.14114",
      "integrations-tracking-lib": "static-1.4986",
      "native-integrations-shared-strings": "static-1.7152",
      "nav-meta": "static-1.27771",
      "outreach-assistant-email-generation": "static-1.4977",
      "property-translator": "static-1.4718",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.35790",
      "react-colorpicker": "static-2.9606",
      "react-dnd-compat": "static-1.4016",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7515",
      "rich-text-lib": "static-1.18675",
      "sales-email-signature-service-client": "static-1.3272",
      "sequences-lib": "static-1.7086",
      "timezone-utils": "static-2.4545",
      "ui-addon-i18n": "static-1.10330",
      "ui-addon-iframeable": "static-1.8259",
      "ui-business-units-lib": "static-1.8266",
      "ui-gdpr-components": "static-1.9574",
      "ui-shepherd-react": "static-3.9414",
      "user-context": "static-1.4533",
      "whatsapp-sending-lib": "static-1.3629",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4075",
      "salesImages": "static-1.511",
      "customer-data-filters-ui-msw-helpers": "static-1.19814",
      "customer-data-reference-ui-components": "static-1.12409",
      "FormUrlGenerator": "static-2.4051",
      "framework-builder-read-service-client": "static-1.3470",
      "framework-data-schema-quick-fetch": "static-1.6141",
      "inbound-db-meta-service-client": "static-1.3129",
      "inbound-db-properties-service-client": "static-1.3351",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.355",
      "onboarding-tours": "static-1.15647",
      "SharedI18nStrings": "static-1.171",
      "ui-addon-teams": "static-1.20691",
      "calling-cross-tab-library": "static-1.18630",
      "calling-global-api": "static-1.62238",
      "calling-integration-cross-tab": "static-1.21341",
      "calling-lifecycle-internal": "static-1.63620",
      "calling-lifecycle-messages": "static-1.55915",
      "conditional-properties-service-client": "static-1.3311",
      "external-options-client-types": "static-1.3519",
      "google-libphonenumber": "static-1.20",
      "inbounddb-objects-service-types": "static-1.3622",
      "object-builder-ui-client": "static-1.46588",
      "pipeline-validation-client-types": "static-1.3315",
      "smart-property-lib": "static-1.4402",
      "tiered-pricing": "static-1.232",
      "ui-addon-form-validation": "static-1.10367",
      "directed-graph": "static-1.277",
      "event-emitter": "static-1.342",
      "fast-json-stable-stringify": "static-1.4",
      "immerable": "static-1.3459",
      "video-components-external": "static-1.9378",
      "video-data-lib": "static-1.33036",
      "audio-components": "static-1.5111",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.34885",
      "video-components": "static-1.11381",
      "video-embed": "static-1.33870",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.23491",
      "knowledge-content-types": "static-1.8036",
      "payment-link-components": "static-1.21855",
      "ui-addon-emoji-picker": "static-1.9277",
      "call-summary": "static-1.36930",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.8567",
      "batch-promise": "static-1.941",
      "feature-store-service-types": "static-1.3995",
      "growth-monetization-service-types": "static-1.4002",
      "merchandise-lib": "static-1.233",
      "self-service-api": "static-1.9595",
      "upgrade-management-service-types": "static-1.3986",
      "chatspot-client-types": "static-1.10005",
      "chatspot-core": "static-1.18855",
      "ContentUtils": "static-1.66291",
      "copilot-toolkit": "static-1.9394",
      "growth-onboarding-feedback-components": "static-1.5843",
      "customer-data-sidebar": "static-2.44263",
      "enrichment-properties-lib": "static-1.13520",
      "persist-promise": "static-1.3099",
      "crm-pipelines-api-client-types": "static-1.3496",
      "customer-data-associations": "static-1.6571",
      "reporting-data": "static-1.64894",
      "ui-addon-draggable": "static-3.4204",
      "crm-record-cards-service-types": "static-1.3088",
      "crm_universal": "static-1.21150",
      "SalesContentIndexUI": "static-3.8147",
      "signup-ui-lego-core": "static-1.19518",
      "content-embed-lib": "static-1.6682",
      "data-model-builder-lib": "static-1.10170",
      "remote-ui": "static-1.51",
      "ui-components-test-utils": "static-1.4995",
      "ui-extensions-remote-renderer": "static-1.15385",
      "universal-page-editor-lib": "static-1.2388",
      "integrations-error-boundary-lib": "static-1.11529",
      "laboratory-lib": "static-3.6536",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9810",
      "rxjs": "static-5.10",
      "ui-universal-auth": "static-1.8200",
      "messaging-types-lib": "static-1.43952",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15308",
      "sequences-client-types-lib": "static-1.6943",
      "foundations-components-test-utils": "static-1.4331",
      "magpie-lib": "static-1.4997",
      "navigation-messaging": "static-1.5461",
      "getting-started-shared-tasks": "static-1.16652",
      "getting-started-shared-tasks-store": "static-1.15770",
      "whatsapp-management-lib": "static-1.6788",
      "growth-data-modal": "static-1.4647",
      "growth-onboarding-confetti": "static-1.2424",
      "growth-onboarding-next-action-utils": "static-1.740",
      "navigation-components": "static-1.16134",
      "ui-shepherd-tracker": "static-1.6795",
      "shared-worker-versioning": "static-1.10413",
      "worker-connection-library": "static-1.15808",
      "calling-orchestration-shared-library": "static-1.33482",
      "onboarding-scopes": "static-1.5864",
      "breeze-intelligence-kit": "static-1.4688",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8504",
      "fsm": "static-1.3042",
      "policy-lib": "static-1.6107",
      "react-tinymce": "static-1.53417",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.52543",
      "tinymce-plugins": "static-1.55657",
      "tinymce-themes": "static-1.54513",
      "commerce-products-lib": "static-1.7585",
      "content-media-composition-data-lib": "static-1.9580",
      "content-media-compositions": "static-2.13587",
      "idb-keyval": "static-1.28",
      "magpie-types": "static-1.4457",
      "media-bridge-lib": "static-1.17908",
      "content-icons-ui": "static-1.2015",
      "social-insights-client-types": "static-1.20229",
      "outpost": "static-1.3672",
      "commerce-analytics-service-client": "static-1.3005",
      "ui-addon-opt": "static-4.7848",
      "commerce-tours-lib": "static-1.5039",
      "growth-onboarding-reliability": "static-1.4472",
      "sales-checkout-service-client": "static-1.3017",
      "ai-addon-copilot-preview": "static-1.6474",
      "wootric-nps": "static-1.6168",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4102",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2341",
      "card-payment-highlight-lib": "static-1.35400",
      "card-subscription-highlight-lib": "static-1.37682",
      "commerce-billing-lib": "static-1.17356",
      "commerce-contract-lib": "static-1.9877",
      "crm_components": "static-3.89904",
      "invoices-highlight-card-lib": "static-1.52693",
      "orders-highlight-card-lib": "static-1.19928",
      "products-highlight-card-lib": "static-1.15870",
      "project-storage": "static-1.4037",
      "quotes-highlight-card-lib": "static-1.69705",
      "usage-based-billing-components-lib": "static-1.6963",
      "reporting-client-types": "static-1.2251",
      "react-flip-move": "static-1.54",
      "FireAlarmUi": "static-1.4019",
      "sales-templates-service-types-lib": "static-1.3581",
      "ui-asset-management-lib": "static-1.10055",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.8481",
      "collaboration-sidebar": "static-1.56095",
      "data-model-commons-lib": "static-1.10803",
      "feedback-loader": "static-1.27996",
      "final-form": "static-1.52",
      "html-to-image": "static-1.37",
      "object-definition-builder-lib": "static-1.6322",
      "property-management-iframe": "static-1.10858",
      "reactflow": "static-1.44",
      "used-in-list-lib": "static-1.6177",
      "visual-association": "static-1.5131",
      "highcharts": "static-8.88",
      "reporting-visualizations": "static-1.56971",
      "ui-extensibility-client-types": "static-1.3392",
      "automation-platform-service-types": "static-1.2319",
      "ContentData": "static-1.66366",
      "email-portal-health-service-types": "static-1.369",
      "marketing-email-service-types": "static-1.1617",
      "reactive-lib": "static-1.90",
      "short-messages-app-service-client": "static-1.3384",
      "ui-tool-access": "static-1.9421",
      "calling-orchestration-schema": "static-1.33707",
      "trellis-story-utils": "static-1.3893",
      "storybook-react": "static-1.15",
      "hub-http-contrib": "static-1.2447",
      "interframe": "static-3.4110",
      "tinymce-data": "static-1.38628",
      "ui-addon-sales-email": "static-1.4545",
      "codemirror": "static-5.79",
      "layout-dnd-components": "static-1.11347",
      "layout-dnd-utils": "static-1.10322",
      "react-codemirror": "static-1.9950",
      "ui-brand-identity-lib": "static-1.12181",
      "NamespacedHubStyle": "static-2.8603",
      "products-iframe-lib": "static-1.6208",
      "products-ui-components-shared-msw-handlers": "static-1.8803",
      "hls.js": "static-1.23",
      "onboarding-tours-client": "static-1.3861",
      "ai-rendering-library": "static-1.8061",
      "ai-settings-ui-library": "static-1.6718",
      "chirp-fetch": "static-1.1336",
      "copilot-plugins": "static-1.9367",
      "commerce-shared-components-lib": "static-1.16828",
      "commerce-subscription-lib": "static-1.35259",
      "commerce-tools-ui-lib": "static-1.8860",
      "usage-tracker-session-replay": "static-1.4460",
      "utility-belt": "static-1.1844",
      "payments-enrollment-embed-lib": "static-1.20579",
      "quotes-ui-lib": "static-1.78421",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.5980",
      "invoices-ui-lib": "static-1.52709",
      "commerce-products-api": "static-1.1277",
      "SafeStorage": "static-1.3727",
      "invoices-iframe-lib": "static-1.54767",
      "quotes-modal-lib": "static-1.100378",
      "reporting-ui-components": "static-2.62168",
      "subscription-experience-data-types": "static-1.13799",
      "association-translator": "static-1.2504",
      "crm-settings-header-lib": "static-1.7544",
      "settings-ui-nav": "static-2.9466",
      "chatspot-widget-iframe": "static-1.18847",
      "collaboration-sidebar-common": "static-1.891",
      "property-management-common": "static-1.3145",
      "d3": "static-1.7",
      "crm-object-map": "static-1.4254",
      "ExportDialog": "static-6.9811",
      "ui-memberships-settings-lib": "static-1.32084",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8647",
      "browser-eslint": "static-2.57",
      "multi-currency-client-types": "static-1.3132",
      "sales-views-client-types": "static-1.3604",
      "highlight.js": "static-1.45",
      "reporting-action-components": "static-1.39543",
      "ui-addon-react-router-dom": "static-1.8946",
      "growth-onboarding-empty-states": "static-1.4846",
      "InboxConnectUtils": "static-4.13150",
      "payments-post-enroll-local-storage-lib": "static-1.4419",
      "qrcode-generator": "static-1.51",
      "trials-service-types": "static-1.3403",
      "amplitude-session-replay-browser": "static-1.44",
      "marketplace-ui-apps-core": "static-1.16283",
      "stripe-embedded-components": "static-1.6474",
      "products-ui-components": "static-1.38105",
      "totals-ui-components": "static-1.21877",
      "reporting-plugins": "static-1.9264",
      "reporting-reports": "static-1.64574",
      "reporting-snowflake": "static-1.53514",
      "crm-index-visualization-object-layout": "static-1.3885",
      "crm-object-search-query-utilities": "static-1.8224",
      "dashboard-lib": "static-1.79083",
      "share-with-third-party-component-lib": "static-1.8047",
      "developer-experience-shared-components": "static-1.9693",
      "marketplace-ui-client-types": "static-1.15156",
      "marketplace-ui-common": "static-1.17749",
      "ui-addon-integrations-directory-panel": "static-2.7392",
      "stripe-connect-js": "static-1.43",
      "property-description-translator": "static-1.3170",
      "commerce-totals-service-types": "static-1.3259",
      "campaign-roi-lib": "static-1.7001",
      "reporting-datasets-permissions-lib": "static-1.11662",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3341",
      "oauth-service-types": "static-1.3590",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26971",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6991",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8262",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15347",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11990",
      "conversations-message-history": "/conversations-message-history/static-1.10563",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9802",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20334",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-promise-utils": "/hs-promise-utils/static-1.4867",
      "hs-test-utils": "/hs-test-utils/static-1.7340",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10857",
      "I18n": "/I18n/static-7.1452",
      "jasmine-immutable": "/jasmine-immutable/static-1.2308",
      "jasmine-runner": "/jasmine-runner/static-1.5765",
      "quartz": "/quartz/static-1.6157",
      "react-dlb": "/react-dlb/static-1.62",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.3882",
      "viral-links-lib": "/viral-links-lib/static-1.6250",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5506",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3909",
      "atom": "/atom/static-1.4495",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4135",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8284",
      "conversations-prop-types": "/conversations-prop-types/static-1.6777",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5113",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19071",
      "cssUtils": "/cssUtils/static-1.601",
      "enviro": "/enviro/static-4.328",
      "flux-actions": "/flux-actions/static-1.286",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9058",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15941",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4734",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3720",
      "sanitize-text": "/sanitize-text/static-1.7495",
      "signup-constants": "/signup-constants/static-1.17508",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.475",
      "usage-tracker": "/usage-tracker/static-1.6774",
      "usage-tracker-core": "/usage-tracker-core/static-1.6624",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5188",
      "usage-tracker-public": "/usage-tracker-public/static-1.6585",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5317",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2879",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5376",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4204",
      "foundations-components": "/foundations-components/static-1.6847",
      "foundations-theming": "/foundations-theming/static-1.3686",
      "UIComponents": "/UIComponents/static-3.7804",
      "cv-backend-services": "/cv-backend-services/static-1.1336",
      "immutable-less": "/immutable-less/static-1.3902",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6706",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31181",
      "icons": "/icons/static-2.595",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "tanstack-virtual": "/tanstack-virtual/static-1.14",
      "rpc-client-utils": "/rpc-client-utils/static-1.4042",
      "ui-images": "/ui-images/static-2.965",
      "permission-components": "/permission-components/static-1.4688",
      "react-virtualized": "/react-virtualized/static-2.81",
      "HeadJS": "/HeadJS/static-2.623",
      "framer-motion": "/framer-motion/static-1.52",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2451",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.134",
      "i18n-data": "/i18n-data/static-1.207",
      "moment-timezone": "/moment-timezone/static-5.67",
      "jasmine": "/jasmine/static-4.3657",
      "quartz-core-utils": "/quartz-core-utils/static-1.3024",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7419",
      "HubStyle": "/HubStyle/static-2.11165",
      "sassPrefix": "/sassPrefix/static-1.140",
      "csstype": "/csstype/static-1.50",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5191",
      "dispatcher": "/dispatcher/static-1.121",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.699",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8421",
      "hubspotter-http": "/hubspotter-http/static-1.3995",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8419",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.395",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11844",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.333",
      "hs-story-utils": "/hs-story-utils/static-1.8708",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3116",
      "floating-ui": "/floating-ui/static-1.40",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1402",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2169",
      "foundations-theming-base": "/foundations-theming-base/static-1.2671",
      "ts-schema": "/ts-schema/static-1.3523",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.1822",
      "content-assistance-lib": "/content-assistance-lib/static-1.6971",
      "crm-component-utils": "/crm-component-utils/static-1.37353",
      "crm-display-components": "/crm-display-components/static-1.23103",
      "crm-fe-perf": "/crm-fe-perf/static-1.22312",
      "crm-links": "/crm-links/static-1.5531",
      "crm-message-bus": "/crm-message-bus/static-1.41165",
      "crm-search-service-types": "/crm-search-service-types/static-1.619",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4632",
      "customer-data-communicator": "/customer-data-communicator/static-1.43719",
      "customer-data-email": "/customer-data-email/static-1.16915",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.37380",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12317",
      "customer-data-objects": "/customer-data-objects/static-1.6983",
      "customer-data-properties": "/customer-data-properties/static-1.49447",
      "customer-data-rte": "/customer-data-rte/static-1.31490",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9113",
      "data-fetching-client": "/data-fetching-client/static-1.9009",
      "draft-plugins": "/draft-plugins/static-2.20508",
      "file-manager-components": "/file-manager-components/static-1.21734",
      "FileManagerCore": "/FileManagerCore/static-1.37233",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7281",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4167",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16440",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.8995",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7392",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16967",
      "universal-associations-select": "/universal-associations-select/static-1.10271",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7105",
      "graphql": "/graphql/static-1.66",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7262",
      "superstore": "/superstore/static-1.4066",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8099",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.26664",
      "card-properties-lib": "/card-properties-lib/static-1.42319",
      "crm-actions": "/crm-actions/static-1.5542",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.41614",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.7748",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7310",
      "customer-data-tracking": "/customer-data-tracking/static-1.6189",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6236",
      "usage-tracker-container": "/usage-tracker-container/static-1.6764",
      "framework-data-table": "/framework-data-table/static-2.10496",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7238",
      "calling-error-reporting": "/calling-error-reporting/static-1.30634",
      "calling-internal-common": "/calling-internal-common/static-1.30628",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5838",
      "crm_data": "/crm_data/static-4.89904",
      "crm_schema": "/crm_schema/static-3.89943",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23134",
      "customer-data-content": "/customer-data-content/static-1.26064",
      "draft-content-plugins": "/draft-content-plugins/static-1.26839",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.22827",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22526",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23062",
      "FileManagerLib": "/FileManagerLib/static-1.37374",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.16432",
      "integration-settings-components": "/integration-settings-components/static-1.13411",
      "integrations-lib": "/integrations-lib/static-1.14114",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4986",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7152",
      "nav-meta": "/nav-meta/static-1.27771",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.4977",
      "property-translator": "/property-translator/static-1.4718",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.35790",
      "react-colorpicker": "/react-colorpicker/static-2.9606",
      "react-dnd-compat": "/react-dnd-compat/static-1.4016",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7515",
      "rich-text-lib": "/rich-text-lib/static-1.18675",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3272",
      "sequences-lib": "/sequences-lib/static-1.7086",
      "timezone-utils": "/timezone-utils/static-2.4545",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10330",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8259",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8266",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9574",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9414",
      "user-context": "/user-context/static-1.4533",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.3629",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4075",
      "salesImages": "/salesImages/static-1.511",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.19814",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12409",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4051",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3470",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6141",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3129",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3351",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.355",
      "onboarding-tours": "/onboarding-tours/static-1.15647",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.171",
      "ui-addon-teams": "/ui-addon-teams/static-1.20691",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18630",
      "calling-global-api": "/calling-global-api/static-1.62238",
      "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.21341",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.63620",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.55915",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3311",
      "external-options-client-types": "/external-options-client-types/static-1.3519",
      "google-libphonenumber": "/google-libphonenumber/static-1.20",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3622",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.46588",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3315",
      "smart-property-lib": "/smart-property-lib/static-1.4402",
      "tiered-pricing": "/tiered-pricing/static-1.232",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10367",
      "directed-graph": "/directed-graph/static-1.277",
      "event-emitter": "/event-emitter/static-1.342",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "immerable": "/immerable/static-1.3459",
      "video-components-external": "/video-components-external/static-1.9378",
      "video-data-lib": "/video-data-lib/static-1.33036",
      "audio-components": "/audio-components/static-1.5111",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.34885",
      "video-components": "/video-components/static-1.11381",
      "video-embed": "/video-embed/static-1.33870",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.23491",
      "knowledge-content-types": "/knowledge-content-types/static-1.8036",
      "payment-link-components": "/payment-link-components/static-1.21855",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9277",
      "call-summary": "/call-summary/static-1.36930",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8567",
      "batch-promise": "/batch-promise/static-1.941",
      "feature-store-service-types": "/feature-store-service-types/static-1.3995",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4002",
      "merchandise-lib": "/merchandise-lib/static-1.233",
      "self-service-api": "/self-service-api/static-1.9595",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3986",
      "chatspot-client-types": "/chatspot-client-types/static-1.10005",
      "chatspot-core": "/chatspot-core/static-1.18855",
      "ContentUtils": "/ContentUtils/static-1.66291",
      "copilot-toolkit": "/copilot-toolkit/static-1.9394",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5843",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44263",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.13520",
      "persist-promise": "/persist-promise/static-1.3099",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3496",
      "customer-data-associations": "/customer-data-associations/static-1.6571",
      "reporting-data": "/reporting-data/static-1.64894",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4204",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3088",
      "crm_universal": "/crm_universal/static-1.21150",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8147",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19518",
      "content-embed-lib": "/content-embed-lib/static-1.6682",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10170",
      "remote-ui": "/remote-ui/static-1.51",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.4995",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15385",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2388",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.11529",
      "laboratory-lib": "/laboratory-lib/static-3.6536",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9810",
      "rxjs": "/rxjs/static-5.10",
      "ui-universal-auth": "/ui-universal-auth/static-1.8200",
      "messaging-types-lib": "/messaging-types-lib/static-1.43952",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15308",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.6943",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4331",
      "magpie-lib": "/magpie-lib/static-1.4997",
      "navigation-messaging": "/navigation-messaging/static-1.5461",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.16652",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.15770",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.6788",
      "growth-data-modal": "/growth-data-modal/static-1.4647",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2424",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.740",
      "navigation-components": "/navigation-components/static-1.16134",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6795",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10413",
      "worker-connection-library": "/worker-connection-library/static-1.15808",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.33482",
      "onboarding-scopes": "/onboarding-scopes/static-1.5864",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4688",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8504",
      "fsm": "/fsm/static-1.3042",
      "policy-lib": "/policy-lib/static-1.6107",
      "react-tinymce": "/react-tinymce/static-1.53417",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.52543",
      "tinymce-plugins": "/tinymce-plugins/static-1.55657",
      "tinymce-themes": "/tinymce-themes/static-1.54513",
      "commerce-products-lib": "/commerce-products-lib/static-1.7585",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.9580",
      "content-media-compositions": "/content-media-compositions/static-2.13587",
      "idb-keyval": "/idb-keyval/static-1.28",
      "magpie-types": "/magpie-types/static-1.4457",
      "media-bridge-lib": "/media-bridge-lib/static-1.17908",
      "content-icons-ui": "/content-icons-ui/static-1.2015",
      "social-insights-client-types": "/social-insights-client-types/static-1.20229",
      "outpost": "/outpost/static-1.3672",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3005",
      "ui-addon-opt": "/ui-addon-opt/static-4.7848",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5039",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4472",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3017",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6474",
      "wootric-nps": "/wootric-nps/static-1.6168",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4102",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2341",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35400",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.37682",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17356",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.9877",
      "crm_components": "/crm_components/static-3.89904",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.52693",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.19928",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.15870",
      "project-storage": "/project-storage/static-1.4037",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.69705",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.6963",
      "reporting-client-types": "/reporting-client-types/static-1.2251",
      "react-flip-move": "/react-flip-move/static-1.54",
      "FireAlarmUi": "/FireAlarmUi/static-1.4019",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3581",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10055",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.8481",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56095",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.10803",
      "feedback-loader": "/feedback-loader/static-1.27996",
      "final-form": "/final-form/static-1.52",
      "html-to-image": "/html-to-image/static-1.37",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6322",
      "property-management-iframe": "/property-management-iframe/static-1.10858",
      "reactflow": "/reactflow/static-1.44",
      "used-in-list-lib": "/used-in-list-lib/static-1.6177",
      "visual-association": "/visual-association/static-1.5131",
      "highcharts": "/highcharts/static-8.88",
      "reporting-visualizations": "/reporting-visualizations/static-1.56971",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3392",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2319",
      "ContentData": "/ContentData/static-1.66366",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.369",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1617",
      "reactive-lib": "/reactive-lib/static-1.90",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3384",
      "ui-tool-access": "/ui-tool-access/static-1.9421",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.33707",
      "trellis-story-utils": "/trellis-story-utils/static-1.3893",
      "storybook-react": "/storybook-react/static-1.15",
      "hub-http-contrib": "/hub-http-contrib/static-1.2447",
      "interframe": "/interframe/static-3.4110",
      "tinymce-data": "/tinymce-data/static-1.38628",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4545",
      "codemirror": "/codemirror/static-5.79",
      "layout-dnd-components": "/layout-dnd-components/static-1.11347",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10322",
      "react-codemirror": "/react-codemirror/static-1.9950",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12181",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8603",
      "products-iframe-lib": "/products-iframe-lib/static-1.6208",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.8803",
      "hls.js": "/hls.js/static-1.23",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.3861",
      "ai-rendering-library": "/ai-rendering-library/static-1.8061",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6718",
      "chirp-fetch": "/chirp-fetch/static-1.1336",
      "copilot-plugins": "/copilot-plugins/static-1.9367",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.16828",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35259",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.8860",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4460",
      "utility-belt": "/utility-belt/static-1.1844",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.20579",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.78421",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.5980",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.52709",
      "commerce-products-api": "/commerce-products-api/static-1.1277",
      "SafeStorage": "/SafeStorage/static-1.3727",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.54767",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.100378",
      "reporting-ui-components": "/reporting-ui-components/static-2.62168",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.13799",
      "association-translator": "/association-translator/static-1.2504",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7544",
      "settings-ui-nav": "/settings-ui-nav/static-2.9466",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.18847",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.891",
      "property-management-common": "/property-management-common/static-1.3145",
      "d3": "/d3/static-1.7",
      "crm-object-map": "/crm-object-map/static-1.4254",
      "ExportDialog": "/ExportDialog/static-6.9811",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32084",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8647",
      "browser-eslint": "/browser-eslint/static-2.57",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3132",
      "sales-views-client-types": "/sales-views-client-types/static-1.3604",
      "highlight.js": "/highlight.js/static-1.45",
      "reporting-action-components": "/reporting-action-components/static-1.39543",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8946",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4846",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13150",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4419",
      "qrcode-generator": "/qrcode-generator/static-1.51",
      "trials-service-types": "/trials-service-types/static-1.3403",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.44",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16283",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6474",
      "products-ui-components": "/products-ui-components/static-1.38105",
      "totals-ui-components": "/totals-ui-components/static-1.21877",
      "reporting-plugins": "/reporting-plugins/static-1.9264",
      "reporting-reports": "/reporting-reports/static-1.64574",
      "reporting-snowflake": "/reporting-snowflake/static-1.53514",
      "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.3885",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.8224",
      "dashboard-lib": "/dashboard-lib/static-1.79083",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8047",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9693",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15156",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.17749",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7392",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "property-description-translator": "/property-description-translator/static-1.3170",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3259",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7001",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.11662",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3341",
      "oauth-service-types": "/oauth-service-types/static-1.3590",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};